export default Object.freeze({
  REGEXP_FOR_EMAIL    : "^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}[.][A-Za-z0-9]{1,}$",
  REGEXP_FOR_PASSWORD : "^[a-zA-Z0-9.?_/-]{4,100}$",
  BASE_URL: process.env.VUE_APP_BASE_URL,
  // BASE_URL: "https://0f9kxjqkpb.execute-api.ap-northeast-1.amazonaws.com/dev",
  // BASE_URL: "https://clek8ugqxb.execute-api.ap-northeast-1.amazonaws.com/prd",
  RECAPTCHA_SITE_KEY: "6Ld-3aUgAAAAACjLE3QyVefU4tx3j5xqYCsOiLiy",
})
